// extracted by css-extract-rspack-plugin
export default {"wrapper":"_d3f1f793"};